import { Permiso } from 'src/app/entities/Enums/permiso.enum';
import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    permiso: Permiso.ConsultarTablero,
    isTitle: true
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARDS.TEXT',
    permiso: Permiso.ConsultarTablero,
    icon: 'uil-home-alt',
    badge: {
      variant: 'primary',
      text: '01',
    },
    link: '/default',
  },
  {
    id: 3,
    label: 'Administración',
    permiso: Permiso.ConsultarAdministracion,
    icon: 'uil-store',
    subItems: [
      {
        id: 4,
        label: 'Módulos',
        permiso: Permiso.ConsultarModulos,
        link: '/administracion/modulos',
        parentId: 3
      },
      {
        id: 5,
        label: 'Permisos',
        permiso: Permiso.ConsultarPermisos,
        link: '/administracion/permisos',
        parentId: 3
      },
      {
        id: 6,
        label: 'Bitácora',
        permiso: Permiso.ConsultarBitacora,
        link: '/administracion/bitacora',
        parentId: 3
      },

    ]
  },
  {
    id: 7,
    label: 'MENUITEMS.CLIENTES.TEXT',
    permiso: Permiso.ConsultarClientes,
    icon: 'uil-user-check',
    subItems: [
      {
        id: 8,
        label: 'MENUITEMS.CLIENTES.LIST.ADDUSER',
        permiso: Permiso.AgregarCliente,
        link: '/clientes/alta-cliente',
        parentId: 7,
      },
      {
        id: 9,
        label: 'MENUITEMS.CLIENTES.LIST.USERLIST',
        permiso: Permiso.ConsultarClientes,
        link: '/clientes/lista-clientes',
        parentId: 7,
      },
    ],
  },
  {
    id: 10,
    label: 'MENUITEMS.USERS.TEXT',
    permiso: Permiso.ConsultarUsuario,
    icon: 'uil-users-alt',
    subItems: [
      {
        id: 11,
        label: 'MENUITEMS.USERS.LIST.ADDUSER',
        permiso: Permiso.AgregarUsuario,
        link: '/usuarios/alta-usuarios',
        parentId: 10,
      },
      {
        id: 12,
        label: 'MENUITEMS.USERS.LIST.USERLIST',
        permiso: Permiso.ConsultarUsuario,
        link: '/usuarios/lista-usuarios',
        parentId: 10,
      },
    ],
  },
  {
    id: 52,
    label: 'Roles',
    permiso: Permiso.ConsultarRoles,
    icon: 'uil-gold',
    subItems: [
      {
        id: 15,
        label: 'Agregar Rol',
        permiso: Permiso.AgregarRol,
        link: '/roles/agregar-rol',
        parentId: 52,
      },
      {
        id: 16,
        label: 'Lista de Roles',
        permiso: Permiso.ConsultarRoles,
        link: '/roles/lista-roles',
        parentId: 52,
      },
    ],
  },
  {
    id: 16,
    label: 'Pasarelas',
    permiso: Permiso.ConsultarServicios,
    isTitle: true,
  },
  {
    id: 17,
    label: 'Servicios',
    permiso: Permiso.ConsultarServicios,
    icon: 'uil-sliders-v-alt',
    subItems: [
      {
        id: 18,
        label: 'Agregar Servicio',
        permiso: Permiso.AgregarServicio,
        link: '/alta-servicio',
        parentId: 17,
      },
      {
        id: 19,
        label: 'Servicios',
        permiso: Permiso.ConsultarServicios,
        link: '/lista-servicios',
        parentId: 17,
      },
    ],
  },
  {
    id: 20,
    label: 'Proveedores',
    permiso: Permiso.ConsultarProvedores,
    icon: 'uil-store-alt',
    subItems: [
      {
        id: 21,
        label: 'Agregar Proveedor',
        permiso: Permiso.AgregarProvedor,
        link: '/agregar-proveedor',
        parentId: 20,
      },
      {
        id: 21,
        label: 'Proveedores',
        permiso: Permiso.ConsultarProvedores,
        link: '/lista-proveedores',
        parentId: 20,
      },
    ],
  },
  {
    id: 10,
    label: 'Facturación',
    permiso: Permiso.ConsultarFacturas,
    icon: 'uil-file',
    subItems: [
      {
        id: 11,
        label: 'Facturas',
        permiso: Permiso.ConsultarFacturas,
        link: '/facturas',
        parentId: 10,
      },
    ],
  },
  {
    id: 13,
    label: 'Pagos a Distancia',
    // permiso: Permiso.ConsultaDePago,
    isTitle: true,
  },
  {
    id: 14,
    label: 'Link de Pago',
    // permiso: Permiso.POSMasivo,
    icon: 'uil-link',
    link: '/link-pago',
  },
  {
    id: 15,
    label: 'Administrar Links',
    // permiso: Permiso.ReporteVentas,
    icon: 'uil-window',
    link: 'links',
  },
  {
    id: 26,
    label: 'Transacciones',
    permiso: Permiso.ConsultarTransaccioes,
    icon: 'uil-file-search-alt',
    link: '/transacciones',
  },
  
  {
    id: 22,
    label: 'Ajustes',
    isTitle: true,
  },
  {
    id: 23,
    label: 'Perfil de Usuario',
    icon: 'uil-chat-bubble-user',
    link: '/contacts/profile',
  },
  {
    id: 24,
    label: 'MENUITEMS.CIERRE.TEXT',
    isTitle: true,
  },
  {
    id: 25,
    label: 'MENUITEMS.CIERRESESION.TEXT',
    icon: 'uil-arrow-circle-right',
    link: '/account/login',
  },

];

